<template>
  <a-modal
    width="600px"
    title="选择品种"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
  >
    <a-alert :message="selectMsg" type="info" show-icon style="margin-top: -10px;"/>
    <a-table
      :row-selection="rowSelection" 
      :pagination="pagination"
      :columns="varietySelectColumns"
      :data-source="list"
      row-key="varietyId"
      :scroll="{y: 300}"
    />
  </a-modal>
</template>

<script>
import {varietySelectColumns} from '../Columns'
import { mapState,mapMutations } from 'vuex';

export default {
  props: ['VarietyDepotCode'],
  data(){
    return{
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
          this.getList()
        }, //选择页数
        onShowSizeChange: ( current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList()
        }, //每页多少条
      },
      varietySelectColumns,
      selectedRowKeys: [],
      selectedRows: [],
      showRow:[],
      list: [],
      // countCS: 0,
      // countLS: 0,
    }
  },
  computed: {
    ...mapState('empirical',['feedVarietyList','varietyVisible','varietySelect']),
    visible: {
      get() {return this.varietyVisible},
      set() {},
    },
    rowSelection(){
      return {
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.varietyId === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys,
        getCheckboxProps(record){
          return ({
            props: {
              disabled: record.varietyLabelCode !== 'chishi' && record.varietyLabelCode !== 'lvshi'
            },
          })
        },
      }
    },
    countCS(){
      let lst = this.selectedRows.filter(el => el.varietyLabelCode === 'chishi') || []
      return lst.length
    },
    countLS(){
      let lst = this.selectedRows.filter(el => el.varietyLabelCode === 'lvshi') || []
      return lst.length
    },
    selectMsg(){
      return <p class='margBm'>
          已选择 <span class='colorRed'>{this.countCS}</span> 种吃食性鱼类， 
          <span class='colorRed'>{this.countLS}</span> 种滤食性鱼类
        </p>
    },
  },
  watch:{
    visible(val){
      if(val){
        this.selectedRowKeys = this.varietySelect.map(el => el.varietyId)
        this.selectedRows = this.varietySelect
        this.getList({current: 1,pageSize: 20})
      }
    },
  },
  methods:{
    ...mapMutations('empirical',['setState']),
    ok() {
      setTimeout(() => {
        this.pagination.current = 1
        this.pagination.pageSize = 20
      }, 200);
      this.setState({varietyVisible: false,varietySelect: JSON.parse(JSON.stringify(this.selectedRows)),})
    },
    cancel() {
      setTimeout(() => {
        this.pagination.current = 1
        this.pagination.pageSize = 20
      }, 200);
      this.setState({varietyVisible: false})
    },
    async getList(pagination) {
      let {current,pageSize} = pagination || this.pagination
      let params = {VarietyDepotCode: this.VarietyDepotCode,current,size:pageSize}
      const res = await this.$http.get("/sat-ruminants/animalvariety/list",{params})
      let data = res.data || {}
      let list = data.records.map(item => {
        let varietyLabelCode = '',varietyLabelName = ''
        item.labels.forEach((el,index) => {
          varietyLabelCode = varietyLabelCode + (index > 0 ? `、${el.labelCode}` : el.labelCode)
          varietyLabelName = varietyLabelName + (index > 0 ? `、${el.labelName}` : el.labelName)
        })
        return {
          // ...item,
          varietyId: item.id,
          varietyName:item.name,
          varietyLabelCode,
          varietyLabelName,
          stockingSpecification: undefined,
          stockingNum: undefined,
          stockingWeight: undefined,
        }
      })
      this.list = list || []
      this.pagination.current = data.current
      this.pagination.pageSize = data.size
      this.pagination.total = data.total
      // this.setState({feedVarietyList: this.feedVarietyList})
    },
  }
}
</script>

<style>

</style>